<template>
  <div
    class="wrapper pa-4"
  >
    <h1 class="d-flex mb-2">
      <span>Hello2</span>
      <VSpacer />
    </h1>
    <div class="relative full-bleed">
      <canvas
        id="scene"
        style="border: 1px solid;max-height: 65vh;width: 100%;"
      />
    </div>
    <p>three.js 应用程序都需要所有这六个步骤</p>
    <p>1. 初始设置</p>
    <p>2. 创建场景</p>
    <p>3. 创建相机</p>
    <p>4. 创建可见对象</p>
    <p>5. 创建渲染器</p>
    <p>6. 渲染场景</p>
    <p><a href="https://discoverthreejs.com/zh/book/first-steps/first-scene/">https://discoverthreejs.com/zh/book/first-steps/first-scene/</a></p>
  </div>
</template>

<script>
/* eslint-disable */
// 1. 初始设置 导入类
import {
  BoxGeometry,
  Color,
  Mesh,
  MeshBasicMaterial,
  PerspectiveCamera,
  Scene,
  WebGLRenderer,
} from 'three';

export default {
  data() {
    return {
      renderer: null,
      scene: null,
      camera: null,
    };
  },
  mounted() {
    this.init3();
  },
  methods: {
    async init3() {
      const container = document.querySelector('#scene');

      // 2. 创建场景
      this.scene = new Scene();
      // 将 场景背景的颜色更改为天蓝色
      this.scene.background = new Color('skyblue');


      // 3. 创建相机
      // Create a camera
      const fov = 35; // AKA Field of View
      const aspect = container.clientWidth / container.clientHeight;
      const near = 0.1; // the near clipping plane
      const far = 1000; // the far clipping plane
      console.log(fov, aspect, near, far, 'fov, aspect, near, far');
      this.camera = new PerspectiveCamera(fov, aspect, near, far);
      this.camera.position.set(2, 2, 10);

      // 4.创建一个可见对象
      const geometry = new BoxGeometry(1, 1, 1);
      const material = new MeshBasicMaterial({color: 0x44aa88});
      const cube = new Mesh(geometry, material);
      this.scene.add(cube);

      // 5. 创建渲染器
      this.renderer = new WebGLRenderer({antialias: true, canvas: container});
      // 设置渲染器的大小 不加默认大小是300*150 放大了会模糊
      this.renderer.setSize(container.clientWidth, container.clientHeight);
      // 设置设备像素比（DPR）
      this.renderer.setPixelRatio(window.devicePixelRatio);
      console.log(window.devicePixelRatio, 'window.devicePixelRatio');

      // 6. 渲染场景
      this.renderer.render(this.scene, this.camera);
    },
  }
}
</script>

<style scoped>
.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}

.wrapper > * {
  grid-column: 2;
}

.full-bleed {
  width: 100%;
  grid-column: 1 / -1;
}

/* 移动端换行 */
a {
  word-break: break-all;
}

</style>